import { AiMatchingRouteGate } from "../components/AiMatchingRouteGate";
import { RegisterLegacy } from "./legacy/RegisterLegacy";
import { RegisterPreview } from "./RegisterPreview";

export const Register = () => (
  <AiMatchingRouteGate preview={<RegisterPreview />} legacy={<RegisterLegacy />} />
);
